import { render, staticRenderFns } from "./Usuarios.vue?vue&type=template&id=d02aba8e&"
import script from "../../src/js/UsuariosCRUD.vue?vue&type=script&lang=js&"
export * from "../../src/js/UsuariosCRUD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports